module.exports = __webpack_public_path__ + "img/page-061.83dd7204.jpg";